<section class="preview-dialog-header">
  <h2>Preview</h2>
  <mds-button
    [type]="'primary'"
    [icon]="'download'"
    [isIconLeft]="true"
    [aria-label]="'Save'"
    [disabled]="!pdfUrl"
    (click)="export()"
  >
    Save
  </mds-button>
</section>

@if (!pdfUrl) {
  <section class="preview-loader">
    <mds-loader></mds-loader>
  </section>
}

@if (pdfUrl) {
  <article #epdV2Viewer class="epd-pdf-viewer">
    <div class="pdf-container">
      <pdf-viewer [src]="pdfUrl" [render-text]="true" [show-borders]="true"></pdf-viewer>
    </div>
  </article>
}
